import {
  InvoiceStatus,
  InvoiceType,
  PaymentMethodType,
  VatRateType,
  InvoiceScheme,
  PrepaymentSettlementStatus,
} from './invoicesTypes';

// Polish labels for UI
export const InvoiceTypeLabels: Record<InvoiceType, string> = {
  [InvoiceType.Standard]: 'Faktura',
  [InvoiceType.Prepayment]: 'Zaliczkowa',
  [InvoiceType.Final]: 'Końcowa',
  [InvoiceType.Correction]: 'Korekta',
  [InvoiceType.Refund]: 'Refundacja PFRON',
  [InvoiceType.Proforma]: 'Proforma',
};

export const InvoiceStatusLabels: Record<InvoiceStatus, string> = {
  [InvoiceStatus.Draft]: 'Szkic',
  [InvoiceStatus.Issued]: 'Wystawiona',
  [InvoiceStatus.Paid]: 'Opłacona',
  [InvoiceStatus.Cancelled]: 'Anulowana',
  [InvoiceStatus.Correction]: 'Korekta',
};

export const PaymentMethodTypeLabels: Record<PaymentMethodType, string> = {
  [PaymentMethodType.Transfer]: 'Przelew',
  [PaymentMethodType.Cash]: 'Gotówka',
};

export const VatRateTypeLabels: Record<VatRateType, string> = {
  [VatRateType.Vat23]: '23%',
  [VatRateType.Vat8]: '8%',
  [VatRateType.Vat5]: '5%',
  [VatRateType.VatZW]: 'ZW (zwolniona z VAT)', // Changed from Vat0
  [VatRateType.VatExempt]: 'ZW (zwolniona)',
  [VatRateType.VatNP]: 'NP (nie podlega)', // Changed from VatNp
  [VatRateType.VatEU]: 'WDT (wewnątrzunijna dostawa)', // NEW
  [VatRateType.VatMargin]: 'Procedura marży',
  [VatRateType.VatRehab]: 'Turnusy rehabilitacyjne', // NEW
  [VatRateType.Vat0Domestic]: '0% (krajowe)', // NEW
};

export const InvoiceSchemeLabels: Record<InvoiceScheme, string> = {
  [InvoiceScheme.Standard]: 'Standard',
  [InvoiceScheme.TravelMargin]: 'Marża biura podróży',
};

export const PrepaymentSettlementStatusLabels: Record<PrepaymentSettlementStatus, string> = {
  [PrepaymentSettlementStatus.Pending]: 'Oczekuje na rozliczenie',
  [PrepaymentSettlementStatus.Settled]: 'Rozliczona',
  [PrepaymentSettlementStatus.PartiallySettled]: 'Częściowo rozliczona',
  [PrepaymentSettlementStatus.Refunded]: 'Zwrócona',
};

// Common option type and helpers for selects
export interface EnumOption<T extends string> {
  value: T;
  label: string;
}

export const InvoiceTypeOptions: EnumOption<InvoiceType>[] = Object.values(InvoiceType).map(
  (v) => ({ value: v, label: InvoiceTypeLabels[v] })
);
export const InvoiceStatusOptions: EnumOption<InvoiceStatus>[] = Object.values(InvoiceStatus).map(
  (v) => ({ value: v, label: InvoiceStatusLabels[v] })
);
export const PaymentMethodTypeOptions: EnumOption<PaymentMethodType>[] = [
  { value: PaymentMethodType.Transfer, label: PaymentMethodTypeLabels[PaymentMethodType.Transfer] },
  { value: PaymentMethodType.Cash, label: PaymentMethodTypeLabels[PaymentMethodType.Cash] },
];
export const VatRateTypeOptions: EnumOption<VatRateType>[] = Object.values(VatRateType).map(
  (v) => ({ value: v, label: VatRateTypeLabels[v] })
);
export const InvoiceSchemeOptions: EnumOption<InvoiceScheme>[] = Object.values(InvoiceScheme).map(
  (v) => ({ value: v, label: InvoiceSchemeLabels[v] })
);
export const PrepaymentSettlementStatusOptions: EnumOption<PrepaymentSettlementStatus>[] =
  Object.values(PrepaymentSettlementStatus).map((v) => ({
    value: v,
    label: PrepaymentSettlementStatusLabels[v],
  }));
